import React from 'react'
import { EventsOfTask } from 'pages/Tasks/types'
import { SNACKBAR_VARIANTS } from 'redesign/components/atoms/snackbar-base/constants'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import type { TimelineBadgeProps } from 'redesign/components/molecules/timeline-badge/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import type { MessageDrawerProps } from 'redesign/services/timeline-action-button/types'
import { MONTH_BUTTON, NEXT_MONTH_MANAGER_TEXTS, THIS_MONTH_MANAGER_TEXTS } from './constants'
import type { GetAcceptMonthButton } from './types'

export const getAcceptMonthButton = ({
  sendEvent,
  refetch,
  setMessageDrawerProps,
  t,
  month,
  openToast,
}: GetAcceptMonthButton) => {
  const isThisMonth = month === MONTH_BUTTON.this
  const TEXT_TRANSLATIONS = isThisMonth ? THIS_MONTH_MANAGER_TEXTS : NEXT_MONTH_MANAGER_TEXTS

  const acceptBadgeProps: TimelineBadgeProps = {
    variant: TIMELINE_BADGE_VARIANTS.success,
    text: TEXT_TRANSLATIONS.acceptBadgeText,
    tooltipText: TEXT_TRANSLATIONS.acceptBadgeTooltipText,
    skipTooltipText: true,
  }

  const acceptDrawerProps: Partial<MessageDrawerProps> = {
    headerLabel: <TimelineBadge {...acceptBadgeProps} />,
    commentText: t(TEXT_TRANSLATIONS.acceptDrawerCommentText),
    isRequired: false,
  }

  const acceptButtonProps: Partial<Action> = isThisMonth
    ? {
        label: t(TEXT_TRANSLATIONS.acceptButtonLabel),
        testId: TEXT_TRANSLATIONS.acceptButtonTestId,
        variant: 'contained',
        color: 'inherit',
      }
    : {
        label: t(TEXT_TRANSLATIONS.acceptButtonLabel),
        testId: TEXT_TRANSLATIONS.acceptButtonTestId,
        variant: 'text',
        color: 'inherit',
      }

  const acceptThisMonthButton: Action = {
    ...getCommentButton({
      t,
      sendEvent,
      refetch,
      setMessageDrawerProps,
      taskEvent: isThisMonth ? EventsOfTask.monthlySheetAcceptThisMonth : EventsOfTask.monthlySheetAcceptNextMonth,
      drawerProps: acceptDrawerProps,
      buttonProps: acceptButtonProps,
      onSuccess: () => openToast?.({ title: t('confirmation.answerSent'), variant: SNACKBAR_VARIANTS.success }),
    }),
  }

  return acceptThisMonthButton
}
